module.exports = __webpack_public_path__ + "img/patrn.67f1a94b.jpg";